import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modal_affected_to_club",
  tabindex: "-1",
  "data-bs-backdrop": "static",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-lg" }
const _hoisted_3 = { class: "modal-content position-relative" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  class: "modal-title",
  id: "varyingModalLabel"
}
const _hoisted_6 = {
  key: 1,
  class: "modal-body"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-12 mb-3" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = {
  key: 0,
  class: "col-md-6 mb-2 mt-2"
}
const _hoisted_11 = { class: "timeline-content" }
const _hoisted_12 = { class: "d-inline-block w-160" }
const _hoisted_13 = {
  key: 1,
  class: "col-md-6 mb-2 mt-2"
}
const _hoisted_14 = { class: "timeline-content" }
const _hoisted_15 = { class: "d-inline-block w-160" }
const _hoisted_16 = {
  id: "data-users",
  class: "datatables table table-striped table-bordered"
}
const _hoisted_17 = { class: "thead-dark" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("th", null, " Club ", -1)
const _hoisted_19 = { style: {"width":"70%"} }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader_gif = _resolveComponent("loader-gif")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.isRequestUser)
          ? (_openBlock(), _createBlock(_component_loader_gif, { key: 0 }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.i18n.t('layout.navbar.modal.user.affected_to_club')), 1),
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal('modal_affected_to_club', 'add'))),
            type: "button",
            class: "btn-close",
            "aria-label": "btn-close"
          })
        ]),
        (_ctx.user)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    (_ctx.user?.firstName || _ctx.user?.lastName)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _createElementVNode("p", _hoisted_11, [
                            _createElementVNode("b", _hoisted_12, _toDisplayString(_ctx.i18n.t('tables.members.name')), 1),
                            _createTextVNode(": " + _toDisplayString(_ctx.user?.firstName ?? '') + " " + _toDisplayString(_ctx.user?.lastName ?? ''), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.user?.email)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          _createElementVNode("p", _hoisted_14, [
                            _createElementVNode("b", _hoisted_15, _toDisplayString(_ctx.i18n.t('tables.members.email')), 1),
                            _createTextVNode(": " + _toDisplayString(_ctx.user?.email), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createElementVNode("table", _hoisted_16, [
                _createElementVNode("thead", _hoisted_17, [
                  _createElementVNode("tr", null, [
                    _hoisted_18,
                    _createElementVNode("th", null, _toDisplayString(_ctx.i18n.t('tables.action')), 1)
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.user?.clubs_user, (club, indexClub) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: club?.club?.id
                    }, [
                      _createElementVNode("td", _hoisted_19, [
                        _createElementVNode("span", null, _toDisplayString(club?.club?.name), 1)
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("button", {
                          class: _normalizeClass(["active_btn active_btn-border-right-none", { 'bg-green': club.is_active }]),
                          onClick: ($event: any) => (_ctx.eventChangeStatus(club?.is_active ? 'true' : 'false', 'true', _ctx.user?.uuid ?? '', club?.club?.uuid))
                        }, _toDisplayString(_ctx.i18n.t("button.enable")), 11, _hoisted_20),
                        _createElementVNode("button", {
                          class: _normalizeClass(["active_btn active_btn-border-left-none", { 'bg-red': !club.is_active }]),
                          onClick: ($event: any) => (_ctx.eventChangeStatus(club?.is_active ? 'true' : 'false', 'false', _ctx.user?.uuid ?? '', club?.club?.uuid))
                        }, _toDisplayString(_ctx.i18n.t("button.disable")), 11, _hoisted_21)
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}